import { DEBOUNCE_DELAY } from '~/vue_shared/components/filtered_search_bar/constants';
import currentUserFrecentGroupsQueryWithDashboards from './graphql/current_user_frecent_groups_with_dashboards.query.graphql';
import DashboardItemsList from './dashboard_items_list.vue?vue3';
import { hasDashboard } from './utils';
export default {
    name: 'DashboardFrequentGroups',
    components: {
        DashboardItemsList
    },
    props: {
        dashboardName: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            frecentGroups: undefined
        };
    },
    apollo: {
        frecentGroups: {
            query: currentUserFrecentGroupsQueryWithDashboards,
            debounce: DEBOUNCE_DELAY
        }
    },
    computed: {
        items () {
            return this.frecentGroups?.filter((group)=>hasDashboard(group, this.dashboardName)) || [];
        }
    }
};
